import Vue, { VNode } from 'vue'
import App from './App.vue'
import VueCompositionApi, { provide } from '@vue/composition-api'
import Composables from '@u3u/vue-hooks'
import AntDesign from './plugins/antDesign'
import GlobalComponents from './plugins/globalComponents'
import VueRouter from 'vue-router'
import PortalVue from 'portal-vue'
import { routes } from './views/routes'
import { provideBreadcrumb } from './composables/useBreadcrumb'
import { provideAuth } from './composables/useAuth'
import { apolloClient } from '@/lib/graphql'
import { DefaultApolloClient } from '@vue/apollo-composable'

Vue.use(VueRouter)
Vue.use(PortalVue)
Vue.use(GlobalComponents)
Vue.use(VueCompositionApi)
Vue.use(Composables)
Vue.use(AntDesign)

require('./styles/main.scss')
// load tailwind after AntDesign

Vue.config.productionTip = false

const router = new VueRouter({
  mode: 'history',
  routes
})

new Vue({
  router,

  // eslint-disable-next-line
  // @ts-ignore
  setup() {
    provideBreadcrumb()

    const { guardRouter } = provideAuth()
    guardRouter(router)

    provide(DefaultApolloClient, apolloClient)
  },

  render(h): VNode {
    return h(App)
  }
}).$mount('#app')
